var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var ServiceSchemaOption = function (props) {
    var innerProps = props.innerProps, data = props.data, isDisabled = props.isDisabled;
    return !isDisabled &&
        React.createElement("div", __assign({ className: "service-schema-option" }, innerProps),
            React.createElement("span", null, data.model.name));
};
export default ServiceSchemaOption;
